import React from "react";
import "../pages/Sidebar.css";

const CountFollower = () => {
  return (
    <div className="box">
      <h3>4.4k</h3>
      <span>Followers</span>
    </div>
  );
};

export default CountFollower;
